import { useState } from "react";
import { Download } from "lucide-react";
import { api, getApiError } from "@/lib/api";
import { downloadStatement } from "@/lib/statement";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const StatementButton = ({ customer, endpoint, testid, size }) => {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(endpoint, { params: { all: true } });
      downloadStatement(customer, data.transactions || []);
    } catch (e) {
      toast.error(getApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button variant="outline" size={size} data-testid={testid} onClick={download} disabled={busy || !customer} className="gap-2">
      <Download className="h-4 w-4" /> {busy ? "Preparing…" : "Statement"}
    </Button>
  );
};
